import "core-js/modules/es.array.concat.js";
export var getURLPage = function getURLPage(page) {
  // @ts-ignore
  var baseUrl = "".concat(window["_baseURL"]);
  switch (page) {
    case "SAVED_SEARCHES":
      //@ts-ignore
      return "".concat(baseUrl, "/").concat(window["_privateURL"], "/").concat(window["_saveSearchesURL"]);
    default:
      throw new Error("There is no matching URL for ".concat(page));
  }
};